import { Loader2 } from "lucide-react";

export function KpiCard({ label, value, sub, icon: Icon, accent = "#0A2E20", testid }) {
  return (
    <div data-testid={testid}
      className="bg-white border border-stone-200 rounded-xl p-6 transition-colors duration-200 hover:border-stone-300">
      <div className="flex items-start justify-between">
        <span className="text-xs uppercase tracking-wider text-[#5C5C54] font-medium">{label}</span>
        {Icon && (
          <span className="h-8 w-8 rounded-lg flex items-center justify-center" style={{ background: `${accent}12` }}>
            <Icon className="h-4 w-4" style={{ color: accent }} />
          </span>
        )}
      </div>
      <div className="mt-3 font-mono text-2xl font-semibold tracking-tight text-[#1A1A1A]">{value}</div>
      {sub && <div className="mt-1 text-xs text-[#5C5C54]">{sub}</div>}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-24 text-[#5C5C54]">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> {label}
    </div>
  );
}

export function EmptyState({ title, hint }) {
  return (
    <div className="text-center py-16 border border-dashed border-stone-300 rounded-xl bg-white/50">
      <div className="font-heading text-lg text-[#1A1A1A]">{title}</div>
      {hint && <div className="text-sm text-[#5C5C54] mt-1">{hint}</div>}
    </div>
  );
}
